import styled from 'styled-components';

import { fonts } from '@dreryk/react-components';

const FormSectionHeader = styled.h3`
   margin: 0 0 18px 0;
   font-weight: ${fonts.fontWeightBold};
`;

FormSectionHeader.displayName = 'FormSectionHeader';

export { FormSectionHeader };
